export class ProjectReportModel {
    constructor() {
        this.projectId = "";
        this.startDateAsString = "";
        this.endDateAsString = "";
        this.employeeIds = [];
        this.isCumulative = false;
    }
}
export default class ProjectReport extends ProjectReportModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
